import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/esnext.promise.all-settled.js";
import { isAsyncIterable } from "../_internal/utils.js";
export var Concurrent = /*#__PURE__*/function () {
  function Concurrent(length) {
    _classCallCheck(this, Concurrent);

    this.length = length;
  }

  _createClass(Concurrent, null, [{
    key: "of",
    value: function of(length) {
      return new Concurrent(length);
    }
  }]);

  return Concurrent;
}();
export var isConcurrent = function isConcurrent(concurrent) {
  return concurrent instanceof Concurrent;
};

function concurrent(length, iterable) {
  var _ref;

  if (iterable === undefined) {
    return function (iterable) {
      return concurrent(length, iterable);
    };
  }

  if (length === Infinity) {
    throw new RangeError("'length' cannot be infinite");
  }

  if (length <= 0) {
    throw new RangeError("'length' must be over 0");
  }

  if (!isAsyncIterable(iterable)) {
    throw new TypeError("'iterable' must be type of AsyncIterable");
  }

  var iterator = iterable[Symbol.asyncIterator]();
  var buffer = [];
  var prev = Promise.resolve();
  var nextCallCount = 0;
  var resolvedItemCount = 0;
  var finished = false;
  var pending = false;
  var settlementQueue = [];

  var consumeBuffer = function consumeBuffer() {
    while (buffer.length > 0 && nextCallCount > resolvedItemCount) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      var p = buffer.shift(); // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

      var _settlementQueue$shif = settlementQueue.shift(),
          _settlementQueue$shif2 = _slicedToArray(_settlementQueue$shif, 2),
          resolve = _settlementQueue$shif2[0],
          reject = _settlementQueue$shif2[1];

      if (p.status === "fulfilled") {
        resolvedItemCount++;
        resolve(p.value);

        if (p.value.done) {
          finished = true;
        }
      } else {
        reject(p.reason);
        finished = true;
        break;
      }
    }
  };

  var fillBuffer = function fillBuffer() {
    if (pending) {
      prev = prev.then(function () {
        return void (!finished && nextCallCount > resolvedItemCount && fillBuffer());
      });
    } else {
      var nextItems = Promise.allSettled(Array.from({
        length: length
      }, function () {
        return iterator.next(Concurrent.of(length));
      }));
      pending = true;
      prev = prev.then(function () {
        return nextItems;
      }).then(function (nextItems) {
        buffer.push.apply(buffer, _toConsumableArray(nextItems));
        pending = false;
        recur();
      });
    }
  };

  function recur() {
    if (finished || nextCallCount === resolvedItemCount) {
      return;
    } else if (buffer.length > 0) {
      consumeBuffer();
    } else {
      fillBuffer();
    }
  }

  return _ref = {}, _defineProperty(_ref, Symbol.asyncIterator, function () {
    return this;
  }), _defineProperty(_ref, "next", function next() {
    nextCallCount++;

    if (finished) {
      return {
        done: true,
        value: undefined
      };
    }

    return new Promise(function (resolve, reject) {
      settlementQueue.push([resolve, reject]);
      recur();
    });
  }), _ref;
}

export default concurrent;